import { Button, Card, Tooltip } from "@mui/material";
import { Edit as EditIcon, Add as AddIcon } from "@mui/icons-material";
import { Vocabulary } from "../../Utils/Vocabulary";
import styles from "../../Styles/websiteIntegration.module.css";
import { WEBSITE_INTEGRATIONS } from "../../Utils/websiteIntegrations";

interface Integration {
  id: number;
  credentials: Record<string, any>;
  websites_integration: { type: string };
}

interface IntegrationCardProps {
  locationId: string;
  locationName: string;
  integrations: Record<string, Integration>;
  onEdit: (locationId: string, integrationType: string) => void;
}

export default function IntegrationCard({
  locationId,
  locationName,
  integrations,
  onEdit,
}: IntegrationCardProps) {
  return (
    <Card className={styles.card}>
      <div className={styles.cardHeader}>
        <h3 className={styles.locationName}>{locationName}</h3>
      </div>

      <div className={styles.cardContent}>
        {WEBSITE_INTEGRATIONS.filter((w) => !w.disabled).map((website) => {
          const integration = integrations[website.code];
          const isConfigured = !!integration;

          return (
            <div key={website.code} className={styles.integrationItem}>
              <span className={styles.integrationName}>{website.name}</span>
              <Tooltip title={`${isConfigured ? Vocabulary.edit : Vocabulary.add} ${website.name}`}>
                <Button
                  onClick={() => onEdit(locationId, website.code)}
                  className={`${styles.editButton} ${isConfigured ? styles.edit : styles.add}`}
                  variant="contained"
                  sx={{
                    backgroundColor: isConfigured ? "#ff6633" : "#4caf50",
                    color: "#ffffff",
                    fontSize: "11px",
                    padding: "5px 10px",
                    textTransform: "none",
                    fontWeight: 500,
                    "&:hover": {
                      backgroundColor: isConfigured ? "#e55a1f" : "#388e3c",
                      boxShadow: isConfigured
                        ? "0 2px 8px rgba(255, 102, 51, 0.3)"
                        : "0 2px 8px rgba(76, 175, 80, 0.3)",
                    },
                  }}
                >
                  {isConfigured ? (
                    <>
                      <EditIcon className={styles.editIcon} />
                      {Vocabulary.edit}
                    </>
                  ) : (
                    <>
                      <AddIcon className={styles.editIcon} />
                      {Vocabulary.add}
                    </>
                  )}
                </Button>
              </Tooltip>
            </div>
          );
        })}
      </div>
    </Card>
  );
}
